import React from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col } from 'react-bootstrap';
import { updateDoctorById } from '../../actions/BusinessUserActions';
import { updateUserById } from '../../actions/UserActions';
import ImageUpload from '../ImageUpload/ImageUpload';

class EditProfilePicture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profilePicture: false
        }
    }

    componentDidMount() {
        this.setState({ profilePicture: this.props.userInfo.profilePicture})
    }

    onchangeText = (value, type) => {
        this.setState({ [type]: value });
    }

    onUpload = () => {
        if(this.props.userInfo.type === 'user'){
            this.props.dispatch(updateUserById(this.props.userInfo.id, {profilePicture: this.state.profilePicture }, this.getCallback))
        }else{
            this.props.dispatch(updateDoctorById(this.props.userInfo.id, {profilePicture: this.state.profilePicture }, this.getCallback))
        }
    }

    onCancel = () => {
        this.props.onCancel && this.props.onCancel()
    }

    getCallback = (data) => {
        this.props.onSuccess && this.props.onSuccess()
    }

    render() {
        return (
            <Row>
                <Col lg={6} md={6} sm={6} xs={12} lgOffset={3} mdOffset={3} smOffset={3}>
                    <ImageUpload image={this.state.profilePicture} height={300} onchangeText={this.onchangeText} column='profilePicture' />
                    {this.state.profilePicture && <Row>
                        <Col lg={6} md={6} sm={6} xs={6} className="padding-10">
                            <button style={{ height: '35px', width: '100%', backgroundColor: '#0984e3', color: '#ffffff', borderRadius: 5 }} type="submit" value="Login" className="loginButton" onClick={this.onUpload}>
                                {this.props.loadTranslations('Upload', this.props.currentLanguage)}
                            </button>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={6} className="padding-10">
                            <button style={{ height: '35px', width: '100%', backgroundColor: '#a3a3a3', color: '#ffffff', borderRadius: 5 }} type="submit" value="Login" className="loginButton" onClick={this.onCancel}>
                                {this.props.loadTranslations('Cancel', this.props.currentLanguage)}
                            </button>
                        </Col>
                    </Row>}
                </Col>
            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        userInfo: state.users.userInfo,
        currentLanguage: state.users.currentLanguage
    };
}

export default connect(mapStateToProps)(EditProfilePicture);



// WEBPACK FOOTER //
// ./screens/EditProfile/EditProfilePicture.js